<template>
  <div>
    <div class="aside" style="position: relative">
      <div class="nav">
        <el-menu
            router
            :default-active="defaultActive"
            text-color="#808191"
            active-text-color="#fff"
            style="height: 100vh; padding: 0 30px 0 35px;"
        >
          <div class="logo" :style="{ padding: isHfut == true ? '50px 0 0' : '50px 0'}">
            <el-image
                @click=""
                style="width: 160px; height: 47px; cursor: pointer; margin-left: -12px"
                :src="url"
                fit="contain">
            </el-image>
          </div>

          <div v-if="isHfut == true" class="logo" style="padding: 0 0 20px 0;">
            <el-image
                @click=""
                style="width: 160px; height: 30px; cursor: pointer; margin-left: -12px"
                :src="urlHfut"
                fit="contain">
            </el-image>
          </div>

          <el-menu-item index="/showcase">
            <i class="iconfont icon-zhanshijia" style="font-size: 25px; padding-right: 10px"></i>
            <span class="my-menu-text" slot="title">{{ $t('common.showcase') }}</span>
          </el-menu-item>
          <el-menu-item index="/training">  <!--   TODO：注意开发中的放开时机   -->
            <i class="iconfont icon-ARTIFICIALNEURALNETWORK" style="font-size: 25px; padding-right: 10px"></i>
            <span class="my-menu-text" slot="title">{{ $t('common.training') }}</span>
          </el-menu-item>
          <el-submenu index="gen">
            <template slot="title">
              <i class="iconfont icon-generate" style="font-size: 25px; padding-right: 10px"></i>
              <span class="my-menu-text" slot="title">{{ $t('common.generate') }}</span>
            </template>
            <el-menu-item index="/textGen">
              <span class="my-menu-text" slot="title">{{ $t('common.textGenerate') }}</span>  <!--文本生成-->
            </el-menu-item>
            <el-menu-item index="/generate">
              <span class="my-menu-text" slot="title">{{ $t('common.imgGenerate') }}</span>  <!--图像生成-->
            </el-menu-item>
            <el-menu-item index="/videoGen">
              <span class="my-menu-text" slot="title">{{ $t('common.videoGenerate') }}</span>  <!--视频生成-->
            </el-menu-item>
            <el-menu-item index="/modelGen">
              <span class="my-menu-text" slot="title">{{ $t('common.modelGenerate') }}</span>  <!--模型生成-->
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <div class="lang" style="position: absolute; bottom: 150px; left: 80px; text-align: center; font-size: 10px; line-height: 23px">
        <span :class="{textBlue: isZh}" @click="changeLang('zh-hans')">中文</span>
        <br>
        <span :class="{textBlue: isEn}" @click="changeLang('en')">English</span>
      </div>
      <div class="lang" style="position: absolute; bottom: 92px; left: 85px; cursor: pointer" @click="goToMyPage">
        <i class="iconfont icon-wode" :class="{textBlue: isMy}" style="color: #FFFFFF; font-size: 30px"></i>
      </div>
      <div class="lang" style="position: absolute; bottom: 40px; left: 85px; cursor: not-allowed">
        <el-dropdown trigger="click" placement="top" @command="settingsCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-s-tools" style="color: #FFFFFF; font-size: 30px"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="iconfont icon-logout" command="logout">{{$t('common.logout')}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>

</template>

<script>
import {delToken} from "@/utils/utils";
import {toLogin} from "@/router/utils";
import {setLang} from "@/lang/utils";

export default {
  inject: ['reload'],
  name: "Aside",
  computed:{
    defaultActive(){
      return this.$route.path
    },
    isZh(){
      return this.lang !== 'en'
    },
    isEn(){
      return this.lang === 'en'
    },
    isMy() {
      return this.$route.name === 'my'
    }
  },

  mounted() {
    let train = this.$route.query.train;
    if(train) {
      let org = this.$route.query.org;
      if(org == 'hfut') {
        this.isHfut = true;
        sessionStorage.setItem('isHfut', '1')
      } else {
        this.isHfut = false;
        sessionStorage.removeItem('isHfut')
      }
    }

    if(!this.isHfut) {
      if(sessionStorage.getItem('isHfut') == '1') {
        this.isHfut = true;
      }
    }
    
  },

  data(){
    return {
      url: require('@/assets/logo2.png'),
      urlHfut: require('@/assets/logo_hfut.png'),
      lang: this.$i18n.locale,
      isHfut: false
    }
  },
  methods: {
    goToMyPage() {
      this.$router.push('/my')
    },
    changeLang(val){
      this.lang = val
      setLang(val)
      this.$router.go(0)
    },
    settingsCommand(command) {
      this[command]()
    },
    logout() {
      delToken()
      toLogin()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-menu {
    background-color: var(--current-aside-color);
    border-color: #4D4B5D;
  }
  .my-menu-text {
    font-size: 14px;
    font-weight: 600;
    color: var(--current-font-color);
  }
  .el-menu-item i {
    color: var(--current-font-color);
  }

  .el-menu-item:hover {
    border-radius: 10px;
    background-color: var(--current-aside-color);
  }

  .el-menu-item.is-active {
    background-color: var(--current-primary-color);
    border-radius: 10px;
  }

  // 子菜单样式
  ::v-deep .el-submenu {
    .el-submenu__title {
      &:hover {
        border-radius: 10px;
        background-color: var(--current-aside-color);
      }
      i {
        color: var(--current-font-color);
      }
    }
    // 子菜单下拉的样式
    .el-menu-item {
      height: 35px;
      line-height: 35px;
      min-width: 0;
      // 子菜单的选中样式
      &.is-active {
        background-color: #828282;
        border-radius: 10px;
      }
    }

    &.is-active {
      .el-submenu__title {
        border-radius: 10px;
        background-color: var(--current-primary-color);
      }
    }
  }

  ::v-deep .el-menu {
    text-align: left;
    background-color: var(--current-aside-color);
  }

  .lang span {
    font-size: 14px;
    cursor: pointer;
    color: var(--current-font-color);
  }

  .textBlue {
    color: var(--current-primary-color) !important;
  }
</style>
